<template>
    <Teleport to="body">
        <section class="edit-point">
            <div class="edit-point-form">
                <button class="edit-point-form__exit-btn"
                        @click=" (e)=> { e.preventDefault(); this.$store.commit('setIsShowAddVotingModalStatus', false) }">
                    <img src="../../../../../assets/icons/components/exit-btn.svg" />
                </button>
                <section class="edit-point-form__form-wrapper">
                    <h2 class="edit-point-form__title">
                        {{ votingToUpdate.id == 0 ? $t('com.file.add-voting-modal.add-voting') : $t('com.file.add-voting-modal.edit-voting') }}
                    </h2>
                    <section class="edit-point-form__row" v-if="getPointIds != null && getPointIds.length == 0">
                        <label class="edit-point-form__label">{{votingToUpdate.is_application ? $t('com.file.add-voting-modal.application-in-case') : $t('com.file.add-voting-modal.voting-in-case')}}</label>
                        <textarea rows="4"
                                  class="edit-point-form__input"
                                  v-model="votingToUpdate.name"
                                  v-error="{ errors, input_key: 'name' }"></textarea>
                        <ErrorMessage v-if="isError('name', this.errors)" :errorMsgs="passErrorMsg('name', this.errors)" />
                    </section>


                    <section class="edit-point-form__checkbox-top" style="margin-bottom:10px;">
                        <section class="edit-point-form__checkbox-wrapper">
                            <input type="checkbox"
                                   class="edit-point-form__checkbox"
                                   :checked="votingToUpdate.is_application" />
                            <section class="edit-point-form__checkbox-mark">
                                <img src="../../../../../assets/icons/components/accept-mark.svg" />
                            </section>
                        </section>
                        <label class="edit-point-form__label edit-point-form__label--checkbox"
                               @click="votingToUpdate.is_application = !votingToUpdate.is_application; votingToUpdate.check_presence = false;">{{$t('com.file.add-voting-modal.application')}}</label>

                        <section class="edit-point-form__checkbox-wrapper">
                            <input type="checkbox"
                                   class="edit-point-form__checkbox"
                                   :checked="votingToUpdate.check_presence" />
                            <section class="edit-point-form__checkbox-mark">
                                <img src="../../../../../assets/icons/components/accept-mark.svg" />
                            </section>
                        </section>
                        <label class="edit-point-form__label edit-point-form__label--checkbox"
                               @click="votingToUpdate.check_presence = !votingToUpdate.check_presence; votingToUpdate.is_application = false; changePresenceOption()">{{$t('com.file.add-voting-modal.check-presence')}}</label>
                    </section>

                    <section class="edit-point-form__section-triple" v-if="!votingToUpdate.check_presence">

                        <section class="edit-point-form__col-triple col-width2">
                            <label class="edit-point-form__label">{{$t('com.file.add-voting-modal.voting-mode')}}</label>
                            <select class="edit-point-form__input"
                                    v-model="votingToUpdate.selected"
                                    @change="votingTypeChanged">
                                <option v-for="s in votingToUpdate.modes" :value="s.id" :key="s.id"> {{s.type}}</option>
                            </select>

                        </section>

                        <section class="edit-point-form__col-triple">
                            <label class="edit-point-form__label">{{$t('com.file.add-voting-modal.quorum')}} [%]</label>
                            <input type="number" min="0" max="100"
                                   class="edit-point-form__input"
                                   v-model="votingToUpdate.kworum"
                                   @change="checkNumber($event)"
                                   v-tooltip="$t('com.file.add-voting-modal.quorum-hint')"
                                   v-error="{ errors, input_key: 'kwor_um' }" />
                            <ErrorMessage v-if="isError('kwor_um', this.errors)" :errorMsgs="passErrorMsg('kwor_um', this.errors)" />
                        </section>

                    </section>

                    <section class="edit-point-form__row">
                        <span class="edit-point-form__tip">{{displayVotingTribeDescription()}}</span>
                    </section>

                    <div class="form-bootstrap-check form-bootstrap-switch" style="padding-bottom: 10px;">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch" id="remember-voting-mode" v-model="rememberSelectedVotingMode" />
                        <label class="form-bootstrap-check-label" for="remember-voting-mode">{{$t('com.file.add-voting-modal.select-voting-mode-to-remember')}}</label>
                    </div>

                    <section class="edit-point-form__row">
                        <label class="edit-point-form__label">{{$t('com.file.add-voting-modal.answers')}}</label>
                        <textarea type="text" rows="4" ref="votinAnserwEditing"
                                  class="edit-point-form__input"
                                  v-model="votingToUpdate.description"
                                  v-error="{ errors, input_key: 'desc_ription' }" :disabled="votingToUpdate.check_presence || votingToUpdate.selected !== 1" />
                        <ErrorMessage v-if="isError('desc_ription', this.errors)" :errorMsgs="passErrorMsg('desc_ription', this.errors)" />
                    </section>

                    <section class="edit-point-form__section-triple" v-if="!votingToUpdate.check_presence">
                        <section class="edit-point-form__col-triple col-width">
                            <label class="edit-point-form__label">{{$t('com.file.add-voting-modal.templates')}}</label>
                            <select ref="templateAnswerSelect"
                                    class="edit-point-form__input"
                                    v-model="votingToUpdate.selected_answers" @click="onChange($event)" :disabled="votingToUpdate.selected !== 1">
                                <option v-for="s in votingToUpdate.templates" :key="s.id"> {{s.temp}}</option>
                            </select>
                        </section>


                        <section class="edit-point-form__col-triple">
                            <label class="edit-point-form__label">{{$t('com.file.add-voting-modal.min-selection')}}</label>
                            <input type="number" min="0"
                                   class="edit-point-form__input"
                                   v-model="votingToUpdate.min"
                                   @change="checkNumberMin($event)"
                                   v-error="{ errors, input_key: 'm_in' }" />
                            <ErrorMessage v-if="isError('m_in', this.errors)" :errorMsgs="passErrorMsg('m_in', this.errors)" />
                        </section>

                        <section class="edit-point-form__col-triple">
                            <label class="edit-point-form__label">{{$t('com.file.add-voting-modal.max-selection')}}</label>
                            <input type="number" min="1"
                                   class="edit-point-form__input"
                                   v-model="votingToUpdate.max"
                                   @change="checkNumberMax($event)"
                                   v-error="{ errors, input_key: 'm_ax' }" />
                            <ErrorMessage v-if="isError('m_ax', this.errors)" :errorMsgs="passErrorMsg('m_ax', this.errors)" />
                        </section>

                    </section>


                    <section class="edit-point-form__point-status" v-if="!votingToUpdate.check_presence">
                        <label class="edit-point-form__label">{{$t('com.file.add-voting-modal.voting-transparency')}}</label>
                        <section class="edit-point-form__checkbox-top">
                            <section class="edit-point-form__checkbox-wrapper">
                                <input type="checkbox"
                                       class="edit-point-form__checkbox"
                                       :checked="votingToUpdate.is_public_voting" />
                                <section class="edit-point-form__checkbox-mark">
                                    <img src="../../../../../assets/icons/components/accept-mark.svg" />
                                </section>
                            </section>
                            <label class="edit-point-form__label edit-point-form__label--checkbox"
                                   @click="votingToUpdate.is_public_voting = !votingToUpdate.is_public_voting; votingToUpdate.is_secret_voting = false">{{$t('com.file.add-voting-modal.public-voting')}}</label>

                            <section class="edit-point-form__checkbox-wrapper">
                                <input type="checkbox"
                                       class="edit-point-form__checkbox"
                                       :checked="votingToUpdate.is_secret_voting"
                                       v-error="{ errors, input_key: 'pub_sec' }" />

                                <section class="edit-point-form__checkbox-mark">
                                    <img src="../../../../../assets/icons/components/accept-mark.svg" />
                                </section>
                            </section>
                            <label class="edit-point-form__label edit-point-form__label--checkbox"
                                   @click="votingToUpdate.is_secret_voting = !votingToUpdate.is_secret_voting; votingToUpdate.is_public_voting = false">{{$t('com.file.add-voting-modal.secret-voting')}}</label>

                        </section>
                        <ErrorMessage v-if="isError('pub_sec', this.errors)" :errorMsgs="passErrorMsg('pub_sec', this.errors)" />
                    </section>

                    <section class="edit-point-form__row" v-if="!votingToUpdate.check_presence">
                        <label class="edit-point-form__label">{{$t('com.file.add-voting-modal.pin-code')}}</label>
                        <input type="text"
                               maxlength="4"
                               :placeholder="$t('com.file.add-voting-modal.pin-code-placeholder')"
                               class="edit-point-form__input"
                               @keypress="onlyNumber"
                               v-model="votingToUpdate.pinCode"
                               v-error="{ errors, input_key: 'pin_code' }" />
                        <ErrorMessage v-if="isError('pin_code', this.errors)" :errorMsgs="passErrorMsg('pin_code', this.errors)" />
                    </section>

                    <section class="edit-point-form__checkbox-section">
                        <label class="edit-point-form__label">{{$t('com.file.add-voting-modal.voting-groups')}}</label>
                        <section v-for="group in groups"
                                 :key="group.id"
                                 class="
                            edit-point-form__checkbox-top
                            edit-point-form__checkbox-top--col
                        ">
                            <CheckBoxButton :id="`${group.id}-comision`"
                                            :value="group.id"
                                            @setGroupId="
                                            (value)=>
                                (this.selected_groups = value)
                                "
                                :idsArray="selected_groups"
                                :checked="
                                selected_groups.indexOf(group.id) !== -1
                                "
                                />
                                <label class="
                                edit-point-form__label
                                edit-point-form__label--checkbox
                                edit-point-form__label--normal
                            "
                                       :for="`${group.id}-comision`">{{ group.name }}</label>
                        </section>
                        <ErrorMessage v-if="isError('selected_groups', this.errors)" :errorMsgs="passErrorMsg('selected_groups', this.errors)" />
                    </section>

                    <section v-if="!votingToUpdate.check_presence">
                        <label class="edit-point-form__label">{{$t('com.file.add-voting-modal.options')}}</label>

                        <div class="form-bootstrap-check" style="padding-left: 0px;" v-if="isRoomMapAddVotingCall === false">
                            <button class="button-excluded" @click="showExcludedUsersModalAction()" :disabled="votingToUpdate.id <= 0">
                                <img src="../../../../../assets/icons/components/user-slash.svg" style="width: 20px;" />
                            </button>
                            <label class="form-bootstrap-check-label">{{$t('com.file.add-voting-modal.exclud-users-from-voting')}} ({{votingToUpdate.excluded_count}})</label>
                            <section name="externalTrigger2"
                                     class="edit-point-form__tip-btn">
                                <img src="../../../../../assets/icons/components/tooltip.svg"
                                     class="edit-point-form__tooltip" />
                                <Hint style="left: calc(100% - 310px)" :title="$t('com.file.add-voting-modal.excluded')"
                                      :text="$t('com.file.add-voting-modal.excluded-hint')" />
                            </section>
                        </div>

                        <div class="form-bootstrap-check" style="padding-left: 0px;" v-if="getPointIds != null && getPointIds.length == 0 && isRoomMapAddVotingCall === false">
                            <button class="button-excluded" @click="showAddMultipleVotingsModalAction()">
                                <img src="../../../../../assets/icons/components/voting-edit-white.svg" style="width: 20px;" />
                            </button>
                            <label class="form-bootstrap-check-label">{{$t('com.file.add-voting-modal.create-multiple-votings')}}</label>
                            <section name="externalTrigger2"
                                     class="edit-point-form__tip-btn">
                                <img src="../../../../../assets/icons/components/tooltip.svg"
                                     class="edit-point-form__tooltip" />
                                <Hint :title="$t('com.file.add-voting-modal.create-multiple-votings')"
                                      :text="$t('com.file.add-voting-modal.create-multiple-votings-hint')" />
                            </section>
                        </div>

                        <div class="form-bootstrap-check form-bootstrap-switch" v-if="isRoomMapAddVotingCall === false">
                            <input class="form-bootstrap-check-input" type="checkbox" role="switch" id="hide-voting" v-model="votingToUpdate.is_hide_voting" />
                            <label class="form-bootstrap-check-label" for="hide-voting">{{$t('com.file.add-voting-modal.hide-voting')}}</label>
                            <section name="externalTrigger2"
                                     class="edit-point-form__tip-btn">
                                <img src="../../../../../assets/icons/components/tooltip.svg"
                                     class="edit-point-form__tooltip" />
                                <Hint :title="$t('com.file.add-voting-modal.hide-voting')"
                                      :text="$t('com.file.add-voting-modal.hide-voting-hint')" />
                            </section>
                        </div>

                        <div class="form-bootstrap-check form-bootstrap-switch">
                            <input class="form-bootstrap-check-input" type="checkbox" role="switch" id="special-voting" v-model="votingToUpdate.is_special_voting" @click="selectSpecialVotingChangeVotingType()" />
                            <label class="form-bootstrap-check-label" for="special-voting">{{$t('com.file.add-voting-modal.run-special-voting')}}</label>
                            <section name="externalTrigger2"
                                     class="edit-point-form__tip-btn">
                                <img src="../../../../../assets/icons/components/tooltip.svg"
                                     class="edit-point-form__tooltip" />
                                <Hint :title="$t('com.file.add-voting-modal.special-voting')"
                                      :text="$t('com.file.add-voting-modal.special-voting-hint')" />
                            </section>
                        </div>

                        <div class="form-bootstrap-check form-bootstrap-switch" v-if="isRoomMapAddVotingCall === false">
                            <input class="form-bootstrap-check-input" type="checkbox" role="switch" id="automatic-voting" v-model="is_automatic" />
                            <label class="form-bootstrap-check-label" for="automatic-voting">{{$t('com.file.add-voting-modal.turn-on-automatic-start-voting')}}</label>
                            <section name="externalTrigger2"
                                     class="edit-point-form__tip-btn">
                                <img src="../../../../../assets/icons/components/tooltip.svg"
                                     class="edit-point-form__tooltip" />
                                <Hint style="left: calc(100% - 310px)" :title="$t('com.file.add-voting-modal.automatic-start-voting')"
                                      :text="$t('com.file.add-voting-modal.automatic-start-voting-hint')" />
                            </section>
                        </div>

                        <!--<section class="edit-point-form__switch-section">

                        <SwitchButton2 label="Automatyczny start głosowania"
                                       :isPublic="is_automatic"
                                       @setIsPublic="(value) => (is_automatic = value)" />
                        <section name="externalTrigger2"
                                 class="edit-point-form__tip-btn">
                            <img src="../../../../../assets/icons/components/tooltip.svg"
                                 class="edit-point-form__tooltip" />
                            <Hint style="left: calc(100% - 310px)" title="Automatyczny start"
                                  text="Po rozpoczęciu głosowania głosowanie trwa wyznaczony czas, następnie jest kończone i pojawia się kolejne w celu jego rozpoczęcia." />
                        </section>
                    </section>-->
                        <section class="edit-point-form__col-double" v-if="is_automatic && isRoomMapAddVotingCall === false">
                            <label class="edit-point-form__label">{{$t('com.file.add-voting-modal.next-voting')}}</label>
                            <select class="edit-point-form__input"
                                    v-model="selectedAutomaticVoting">
                                <option v-for="s in automaticVotingOptions" :value="s.id" :key="s.id"> {{s.type}}</option>
                            </select>
                        </section>

                    </section>

                    <section class="edit-point-form__buttons-bottom gap-2" style="padding: 0px;">
                        <button class="edit-point-form__bottom-button"
                                @click="(e)=> { e.preventDefault(); this.$store.commit('setIsShowAddVotingModalStatus', false); }">
                            {{$t('com.global.cancel')}}
                        </button>
                        <button class="
                            edit-point-form__bottom-button
                            edit-point-form__bottom-button--red" style="width: 246px" @click="handleSaveVoting()">
                            {{$t('com.global.save')}}
                        </button>
                    </section>
                    <section class="edit-point-form__buttons-bottom gap-2" style="margin-top: 10px; padding-bottom: 56px;">
                        <button v-if="isInteractive && getPointIds != null && getPointIds.length == 0 && getInteractiveVotingModalInAppStatus === false" style="flex: 1;" class="
                            edit-point-form__bottom-button
                            edit-point-form__bottom-button--red" @click="handleSaveVotingAndStart()">
                            {{$t('com.file.add-voting-modal.save-and-run')}}
                        </button>
                    </section>
                </section>
            </div>
            <LoaderInside v-if="isLoading" />
            <Transition>
                <ExcludedUsersModal v-if="showExcludedUsersModal && votingToUpdate.id > 0" :vname="votingToUpdate.name" :basicData="basicData" @closeExcludedUsersModal="closeExcludedUsersModal" @saveExcludedUsers="saveExcludedUsers" />
            </Transition>
            <Transition>
                <MultipleVotingsModal v-if="showMultipleVotingModal" :globalParametersForMultiple="globalParametersForMultiple" @closeAddMultipleVotingsModalAction="closeAddMultipleVotingsModalAction" @saveMultipleVotings="saveMultipleVotingsForPoint" />
            </Transition>
        </section>
    </Teleport>
</template>

<script charset="utf-8">
    //import SwitchButton2 from "../../../../BasicControls/SwitchButtonUni.vue";
    import Hint from "../../../../BasicControls/Hint.vue";
    import CheckBoxButton from "../../../../BasicControls/CheckBoxButton.vue";
    import LoaderInside from "../../../../BasicControls/LoaderInside.vue";
    import ErrorMessage from "../../../../BasicControls/ErrorMessage.vue";
    import MeetingService from "../../../../../services/meetings.service";
    import VotingService from "../../../../../services/voting.service";
    import settingsService from "../../../../../services/settings.service";
    import { encryptStorage } from "../../../../../services/encrypt.service"
    import ExcludedUsersModal from "../Modals/ExcludedUsersModal.vue"
    import MultipleVotingsModal from "../Modals/AddMultipleVotingsModal"
    import {
        passErrorMsg,
        isError,
        setErrors,
    } from "../../../../../formValidation/main";

    export default {
        name: "AddEditVoting",
        data() {
            return {
                selected_groups: [],
                groups: [],
                isLoading: false,
                errors: [],
                temSelectedDescriptionForApplication: '',
                basicData: {},
                pointName: "",
                globalParametersForMultiple: {},
                showExcludedUsersModal: false,
                showMultipleVotingModal: false,
                votingToUpdate: {},
                is_automatic: this.$store.state.interactiveStore.startAutomaticVotingByTimeSet.isAutomatic,
                disableChangeAnswers: false,
                automaticVotingOptions: [
                    { id: 5, type: this.$t('com.file.add-voting-modal.after-5-sec')},
                    { id: 10, type: this.$t('com.file.add-voting-modal.after-10-sec') },
                    { id: 15, type: this.$t('com.file.add-voting-modal.after-15-sec') },
                    { id: 20, type: this.$t('com.file.add-voting-modal.after-20-sec') },
                    { id: 30, type: this.$t('com.file.add-voting-modal.after-30-sec') },
                    { id: 60, type: this.$t('com.file.add-voting-modal.after-60-sec') },
                    { id: 120, type: this.$t('com.file.add-voting-modal.after-120-sec') },
                    { id: 180, type: this.$t('com.file.add-voting-modal.after-180-sec') },
                ],
                selectedAutomaticVoting: this.$store.state.interactiveStore.startAutomaticVotingByTimeSet.time,
                globalSettings: encryptStorage.getItem('modules').gs,
                rememberSelectedVotingMode: false
            };
        },
        components: {
            CheckBoxButton,
            LoaderInside,
            ErrorMessage,
            Hint,
            ExcludedUsersModal,
            MultipleVotingsModal
        },
        props: {
            voting: Object,
        },
        computed: {
            isInteractive() {
                return this.$store.state.appStore.isInInteractiveMode;
            },
            isRememberVotingMode() {
                return this.$store.state.settings.runtime.rememberVotingMode;
            },
            getRememberVotingModeValue() {
                return this.$store.state.settings.runtime.rememberVotingModeValue;
            },
            getVotingMode() {
                return this.$store.state.votingStore.votingMode;
            },
            getPointIds() {
                return this.$store.state.votingStore.votingPoints;
            },
            getSessionId() {
                return this.$store.state.votingStore.sessionId;
            },
            getSelectedVotingId() {
                return this.$store.state.votingStore.selectedVoting;
            },
            getSelectedPoint() {
                return this.$store.state.votingStore.selectedPoint;
            },
            isCopyVoting() {
                return this.$store.state.votingStore.isCopyVoting;
            },
            isRoomMapAddVotingCall() {
                return this.$store.state.votingStore.isRoomMapAddVotingCall;
            },
            getInteractiveVotingModalInAppStatus() {
                return this.$store.state.votingStore.interactiveVotingModalInAppStatus;
            }
        },
        methods: {
            async changeRememberVotingMode(mode) {
                try {
                    let data = { ...this.$store.state.settings.runtime };
                    data.rememberVotingModeValue = mode;
                    data.rememberVotingMode = this.rememberSelectedVotingMode;

                    this.globalSettings == 0 ? await settingsService.updateUserVotingSettings(data) : await settingsService.updateClientSettings(data);
                }
                catch (e) {
                    console.log(e);
                }
            },
            saveExcludedUsers(users) {

                VotingService.excludeUserFromVoting(this.votingToUpdate.id, this.votingToUpdate.sid, users)
                    .then((response) => {
                        this.showExcludedUsersModal = false;
                        this.basicData = {};
                        this.votingToUpdate.excluded_count = response.data;
                    });
            },
            closeExcludedUsersModal() {
                this.showExcludedUsersModal = false;
                this.basicData = {};
            },
            showExcludedUsersModalAction() {

                VotingService.getUsersForVotingExcluded(this.votingToUpdate.id, this.votingToUpdate.sid)
                    .then((response) => {
                        this.basicData = response.data;
                        this.showExcludedUsersModal = true;
                    });
            },
            showAddMultipleVotingsModalAction() {
                this.errors = [];
                if (this.validate(this.votingToUpdate) == false)
                    return;

                var data = {
                    id: 0,
                    pid: this.votingToUpdate.pid,
                    sid: this.votingToUpdate.sid,
                    name: this.votingToUpdate.name,
                    description: this.votingToUpdate.description,
                    kworum: this.votingToUpdate.kworum,
                    max: this.votingToUpdate.max,
                    min: this.votingToUpdate.min,
                    pinCode: this.votingToUpdate.pinCode,
                    is_public_voting: this.votingToUpdate.is_public_voting,
                    is_secret_voting: this.votingToUpdate.is_secret_voting,
                    is_application: this.votingToUpdate.is_application,
                    check_presence: this.votingToUpdate.check_presence,
                    is_special_voting: this.votingToUpdate.is_special_voting,
                    selected_groups: this.selected_groups,
                    selected_answers: this.votingToUpdate.selected_answers,
                    selected: this.votingToUpdate.selected,
                    hide: this.votingToUpdate.is_hide_voting,
                };

                this.globalParametersForMultiple = data;
                this.showMultipleVotingModal = true;
            },
            closeAddMultipleVotingsModalAction() {
                this.showMultipleVotingModal = false;
                this.globalParametersForMultiple = {};
            },
            saveMultipleVotingsForPoint() {
                this.globalParametersForMultiple = {};
                this.showMultipleVotingModal = false;
                this.requestSuccess();
            },
            onlyNumber($event) {
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                if ((keyCode < 48 || keyCode > 57)) {
                    $event.preventDefault();
                }
            },
            votingTypeChanged() {
                let matchTemplateAnswer = this.votingToUpdate.templates.find(answer => {
                    return answer.temp.includes(this.$t('com.file.interactive-voting-public-modal.vote-for'));
                })
                if (this.votingToUpdate.selected != 1) {
                    this.$refs.votinAnserwEditing.disabled = true;
                    this.$refs.templateAnswerSelect.disabled = true;
                    this.votingToUpdate.selected_answers = matchTemplateAnswer.temp;
                    this.setDataToDescription(this.votingToUpdate.selected_answers);
                    this.votingToUpdate.is_special_voting = false;
                }
                else {
                    this.$refs.votinAnserwEditing.disabled = false;
                    this.$refs.templateAnswerSelect.disabled = false;
                }
            },
            displayVotingTribeDescription() {
                switch (this.votingToUpdate.selected) {
                    case 1:
                        return "";
                    case 2:
                        return this.$t('com.file.add-voting-modal.voting-mode-case-2-info');
                    case 3:
                        return this.$t('com.file.add-voting-modal.voting-mode-case-3-info');
                    case 4:
                        return this.$t('com.file.add-voting-modal.voting-mode-case-4-info');
                    case 5:
                        return this.$t('com.file.add-voting-modal.voting-mode-case-5-info');
                    default:
                        return "";
                }
            },
            changePresenceOption() {
                if (this.votingToUpdate.check_presence) {
                    this.pointName = this.votingToUpdate.name;
                    this.votingToUpdate.description = this.$t('com.file.add-voting-modal.presence');
                    this.votingToUpdate.name = this.$t('com.file.add-voting-modal.check-presence');
                }
                else {
                    this.setDataToDescription(this.votingToUpdate.templates[0].temp);
                    this.votingToUpdate.name = this.pointName;
                }
            },
            selectSpecialVotingChangeVotingType() {
                this.votingToUpdate.is_special_voting = !this.votingToUpdate.is_special_voting;

                if (this.votingToUpdate.is_special_voting) {
                    this.votingToUpdate.selected = 1;
                    this.$refs.votinAnserwEditing.disabled = false;
                    this.$refs.templateAnswerSelect.disabled = false;
                }
            },
            validate(data) {
                var bo = true;
                var err = {};
                if(data.name.trim().length <= 0 && !data.forMultipleData){
                    err.name = [this.$t('com.global.required-field')];
                    bo = false;
                }

                if (data.description.trim().length <= 0) {
                    err.desc_ription = [this.$t('com.validation-error.complete-answer-or-select-template-error')]
                    bo = false
                }

                if (data.is_secret_voting == false && data.is_public_voting == false) {
                    err.pub_sec = [this.$t('com.validation-error.select-voting-transparency-error')]
                    bo = false
                }

                if (this.selected_groups.length < 1) {
                    err.selected_groups = [this.$t('com.validation-error.select-voting-groups-error')]
                    bo = false
                }

                if (data.pinCode.length > 0 && data.pinCode.length != 4) {
                    err.pin_code = [this.$t('com.validation-error.pin-4-number-error')]
                    bo = false
                }

                if (!bo) {
                    this.isLoading = false;
                    this.errors = setErrors(err)
                }
                return bo
            },
            onChange(event) {
                this.setDataToDescription(event.target.value);
            },
            checkNumber(event) {
                if (event.target.value > 100) {
                    this.votingToUpdate.kworum = 100;
                }
                else if (event.target.value < 0) {
                    this.votingToUpdate.kworum = 0;
                }
                else {
                    if (event.target.value.includes(".")) {
                        this.votingToUpdate.kworum = event.target.value.split(".")[0];
                    }

                    if (event.target.value.includes(",")) {
                        this.votingToUpdate.kworum = event.target.value.split(",")[0];
                    }

                }
            },
            checkNumberMin(event) {
                if (event.target.value < 0) {
                    this.votingToUpdate.min = 0;
                }
            },
            checkNumberMax(event) {
                if (event.target.value <= 0) {
                    this.votingToUpdate.max = 1;
                }
            },
            setDataToDescription(stringData) {
                this.votingToUpdate.description = '';
                var des = stringData.split('/');
                for (var i = 0; i < des.length; i++) {
                    this.votingToUpdate.description += des[i] + '\r\n';
                }
            },
            async internalSaveVoting() {
                this.errors = [];
                if (this.validate(this.votingToUpdate) == false)
                    throw new Error("Failed to validate request data");

                var data = {
                    id: this.votingToUpdate.id,
                    sid: this.votingToUpdate.sid,
                    name: this.votingToUpdate.name,
                    description: this.votingToUpdate.description,
                    kworum: this.votingToUpdate.kworum,
                    max: this.votingToUpdate.max,
                    min: this.votingToUpdate.min,
                    pinCode: this.votingToUpdate.pinCode,
                    is_public_voting: this.votingToUpdate.is_public_voting,
                    is_secret_voting: this.votingToUpdate.is_secret_voting,
                    is_application: this.votingToUpdate.is_application,
                    check_presence: this.votingToUpdate.check_presence,
                    is_special_voting: this.votingToUpdate.is_special_voting,
                    selected_groups: this.selected_groups,
                    selected_answers: this.votingToUpdate.selected_answers,
                    selected: this.votingToUpdate.selected,
                    hide: this.votingToUpdate.is_hide_voting,
                };

                if (this.getPointIds != null && this.getPointIds.length > 0) {

                    data.pids = this.getPointIds;

                    let response = await VotingService.addVotingToMultiplePoints(this.votingToUpdate.sid, data);
                    if (response.status !== 200) {
                        throw await Promise.reject(response);
                    }

                }
                else {

                    data.pid = this.votingToUpdate.pid;

                    let response = await VotingService.addOrUpdateVoting(this.votingToUpdate.pid, data)
                    if (response.status !== 200) {
                        throw await Promise.reject(response);
                    }
                    this.votingToUpdate.id = response.data.id;
                }

                await this.changeRememberVotingMode(data.selected);
                
            },
            async handleSaveVotingAndStart() {
                try {
                    this.isLoading = true;
                    await this.internalSaveVoting();

                    this.$store.commit('setStartVotingData', {
                        pointId: this.votingToUpdate.pid,
                        votingId: this.votingToUpdate.id,
                    })

                    this.$store.commit('setStartVotingStatus', true)

                    this.requestSuccess();
                }
                catch{
                    this.requestError()
                }
                finally {
                    this.isLoading = false;
                }
            },
            async handleSaveVoting() {
                try {
                    this.isLoading = true;
                    await this.internalSaveVoting();
                    this.requestSuccess();
                }
                catch {
                    this.requestError()
                }
                finally {
                    this.isLoading = false;
                }
            },
            requestSuccess() {
                this.votingToUpdate = {};
                this.groups = [];
                this.errors = [];
                this.selected_groups = [];
                this.isLoading = false;

                this.$store.commit('setSaveVotingStatus', true)
                var data = { isAutomatic: this.is_automatic, time: this.selectedAutomaticVoting };
                this.$store.commit("setStartAutomaticVoting", data);
                this.$store.commit('setIsShowAddVotingModalStatus', false)
},
            requestError() {
                this.isLoading = false;
            },
            getVotingDataTemplate(name, pointId) {

                var description = this.$t('com.file.interactive-voting-public-modal.vote-for') + "\r\n" + this.$t('com.file.interactive-voting-public-modal.vote-against') + "\r\n" + this.$t('com.file.interactive-voting-public-modal.vote-abstain');
                var selected_answers = this.$t('com.file.interactive-voting-public-modal.vote-for') + "/" + this.$t('com.file.interactive-voting-public-modal.vote-against') + "/" + this.$t('com.file.interactive-voting-public-modal.vote-abstain');
                var yes_no = this.$t('com.file.interactive-voting-public-modal.vote-yes') + "/" + this.$t('com.file.interactive-voting-public-modal.vote-no') + "/" + this.$t('com.file.interactive-voting-public-modal.vote-dont-know');
                var for_against = this.$t('com.file.interactive-voting-public-modal.vote-for') + "/" + this.$t('com.file.interactive-voting-public-modal.vote-against');

                return {
                    name: name,
                    description: description,
                    kworum: 0,
                    max: 1,
                    min: 1,
                    selected_answers: selected_answers,
                    is_public_voting: true,
                    is_secret_voting: false,
                    is_application: false,
                    check_presence: false,
                    is_special_voting: false,
                    selected: 1,
                    sid: this.getSessionId,
                    pid: pointId,
                    selected_groups: [],
                    pinCode: '',
                    modes: [],
                    templates: [{ id: 1, temp: selected_answers }, { id: 2, temp: yes_no }, { id: 3, temp: for_against }],
                    id: 0,
                    is_hide_voting: false,
                    excluded_count: 0
                }
            },
            mapVotingTemplateToData(data, result) {
                data.modes = result.modes;
                data.name = result.voting.name;
                data.description = result.voting.description;
                data.kworum = result.voting.kworum;
                data.max = result.voting.max;
                data.min = result.voting.min;
                data.selected_answers = result.voting.selected_answers;
                data.is_public_voting = result.voting.is_public_voting;
                data.is_secret_voting = result.voting.is_secret_voting;
                data.is_application = result.voting.is_application;
                data.check_presence = result.voting.check_presence;
                data.is_special_voting = result.voting.is_special_voting;
                data.selected = result.voting.selected;
                data.sid = this.getSessionId;
                data.selected_groups = result.voting.selected_groups;
                data.pinCode = result.voting.pinCode;
                data.id = result.voting.id;
                data.is_hide_voting = result.voting.hide;
                data.excluded_count = result.voting.excluded_count;
                return data;
            },
            async getVotingData(item, edit) {
                try {
                    var data = { ...this.getVotingDataTemplate(item.name, item.id) };
                    if (edit == null) {
                        var result1 = (await VotingService.getBasicVotingModesData()).data;
                        if (Object.keys(result1).length > 0) {
                            data.modes = result1;
                        }
                    }
                    else {
                        var result = (await VotingService.getVotingData(edit, item.id, this.getSessionId)).data;
                        if (Object.keys(result).length > 0) {

                            data = { ...this.mapVotingTemplateToData({ ...data }, { ...result }) }
                        }
                    }
                    this.votingToUpdate = data;
                    this.votingToUpdate.forMultipleData = true
                    this.selected_groups = [...this.votingToUpdate.selected_groups];
                    this.pointName = this.votingToUpdate.name;

                } catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },
            async getCopyVoting(item, voting) {
                try {
                    const recapitulation = this.$t('com.file.edit-meeting-points.recapitulation');
                    let response = await VotingService.getVotingData(voting, item.id, this.getSessionId);
                    let data = { ...this.getVotingDataTemplate(response.data.voting.name, item.id) };
                    data = { ...this.mapVotingTemplateToData({ ...data }, { ...response.data }) }
                    data.name = `${data.name} (${recapitulation})`;
                    data.id = 0;
                    this.votingToUpdate = data;
                    this.selected_groups = [...this.votingToUpdate.selected_groups];
                    this.pointName = this.votingToUpdate.name;
                }
                catch (e) {
                    console.log(e);
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },
            passErrorMsg,
            isError,
            setErrors,
        },
        async mounted() {
            try {
                this.isLoading = true;

                if (this.isCopyVoting) {
                    await this.getCopyVoting(this.getSelectedPoint, this.getSelectedVotingId);
                }
                else {
                    await this.getVotingData(this.getSelectedPoint, this.getSelectedVotingId);
                }
                
                let response = await MeetingService.groupsForVoting(this.votingToUpdate.sid);
                if (response.status !== 200) {
                    throw await Promise.reject(response);
                }
                this.groups = response.data;

                if (this.votingToUpdate.id == 0 && this.getVotingMode === "standard") {
                    this.selected_groups = [];
                    for (var i = 0; i < this.groups.length; i++) {
                        this.selected_groups.push(this.groups[i].id);
                    }
                }

                if (this.isRememberVotingMode === true && this.votingToUpdate.id === 0) {
                    this.rememberSelectedVotingMode = this.isRememberVotingMode;
                    this.votingToUpdate.selected = this.getRememberVotingModeValue;
                    this.votingTypeChanged();
                }   

            }
            finally {
                this.isLoading = false;
            }
        },
    };
</script>

<style lang="scss" scoped>
    .button-excluded {
        border: 1px solid #bbc2ce;
        box-sizing: border-box;
        //border-radius: 3px;
        font-weight: 300;
        font-size: 15px;
        line-height: 132%;
        background: #d80418;
        color: white;
        width: 42px;
        height: 24px;
        border-radius: 100px;
        margin-left: 5px;

        &:hover {
            background: #ad0313 !important;
        }

        &:disabled {
            background: #00082c75 !important;
            cursor: default;
        }
    }


    .col-width {
        min-width: 400px;
    }

    .col-width2 {
        min-width: 500px;
    }

    .edit-point {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100vw;
        height: 100vh;
        background: #00082c75;
        z-index: 9;
    }

    .edit-point-form {
        padding: 32px 56px;
        background: linear-gradient(146.23deg, #f4f8ff 0%, #ffffff 100%);
        border: 2px solid #ffffff;
        box-sizing: border-box;
        box-shadow: 24px 40px 120px rgba(0, 8, 44, 0.32);
        border-radius: 12px;
        max-height: 90vh;
        padding-bottom: 0px;
        padding-right: 0px;

        &__form-wrapper {
            max-height: 80vh;
            overflow-y: auto;
            padding-right: 56px;

            &::-webkit-scrollbar {
                width: 12px;
                height: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: #b5b8bd;
                border-radius: 30px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: #b5b8bd;
            }

            &::-webkit-scrollbar-track {
                background: #ffffff;
                border: 0.8px solid #dce4ee;
                border-radius: 30px;
                box-shadow: inset 0px 0px 0px 0px #f0f0f0;
            }
        }

        &__exit-btn {
            border: 0px;
            background-color: transparent;
            position: relative;
            right: calc(-100% + 48px);
        }

        &__row {
            margin-bottom: 10px;
        }

        &__title {
            font-weight: 600;
            font-size: 28px;
            line-height: 128%;
            color: #00082c;
            width: 100%;
            padding-bottom: 32px;
            //margin-bottom: 16px;

            &--small {
                font-size: 20px;
                border-bottom: 0px;
                padding-bottom: 16px;
                margin: 0px;
            }

            &--no-padding {
                padding: 0px;
            }

            &--comission {
                width: 100%;
                margin-top: 30px;
                padding-top: 28px;
                border-top: 1px solid #dde0e7;
            }
        }

        &__section-double {
            display: flex;
            justify-content: space-between;
            width: 600px;
        }

        &__col-double {
            width: 238px;
        }

        &__section-triple {
            display: flex;
            justify-content: space-between;
            width: 600px;
        }

        &__col-triple {
            width: 90px;
        }

        &__input {
            width: 100%;
            padding: 12.5px 16px;
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
            border-radius: 4px;
            margin: 8px 0px;
            font-size: 16px;
            line-height: 144%;
            color: #00082c;

            &:focus {
                border: 1px solid #00082c;
            }

            &:disabled {
                background: rgba(0, 0, 0, 0.2);
            }
        }

        &__label {
            font-weight: 600;
            font-size: 14px;
            line-height: 145%;
            color: #00082c;

            &--checkbox {
                padding-left: 32px;
                z-index: 10;
                cursor: pointer;
                font-weight: normal !important;
            }

            &--normal {
                font-weight: normal !important;
            }
        }

        &__tip {
            font-weight: 300;
            font-size: 12px;
            line-height: 145%;
            color: #00082c;
        }

        &__point-status {
            display: flex;
            flex-direction: column;
            //margin-top: 32px;
            padding-bottom: 32px;
            //border-bottom: 1px solid #dde0e7;
            //margin-bottom: 24px;
        }

        &__checkbox-top {
            display: flex;
            align-items: center;
            margin-top: 12px;

            &--col {
                margin-bottom: 13px;
                align-items: flex-start;
            }
        }

        &__checkbox {
            width: 0px;
            height: 0px;
            display: none;

            &:checked ~ .edit-point-form__checkbox-mark {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            &:checked ~ .add-contact-form__label--checkbox {
                padding-left: 0px;
            }
        }

        &__checkbox-wrapper {
            width: 0px;
            height: 24px;
            position: relative;
            margin-left: 20px;

            &:before {
                content: "";
                background: #ffffff;
                border: 1px solid #d1d6df;
                box-sizing: border-box;
                box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
                border-radius: 4px;
                width: 24px;
                height: 24px;
                position: relative;
                display: block;
                top: 0px;
                left: 0px;
                opacity: 1;
            }
        }

        &__checkbox-mark {
            background: #00082c;
            border: 1px solid #00082c;
            box-sizing: border-box;
            box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
            border-radius: 4px;
            width: 24px;
            height: 24px;
            position: absolute;
            z-index: 5;
            display: none;
            top: 0px;
            left: 0px;
            opacity: 1;
        }

        &__buttons-bottom {
            display: flex;
            justify-content: space-between;
            margin-top: 40px;
            padding-bottom: 56px;
        }

        &__bottom-button {
            padding: 18px 40px 17px;
            width: 238px;
            height: 56px;
            border: 1px solid #bbc2ce;
            box-sizing: border-box;
            border-radius: 4px;
            font-weight: 500;
            font-size: 16px;
            line-height: 132%;
            color: #00082c;
            background: transparent;
            transition: all 0.2s ease-in-out;

            &:hover {
                background: #e8ebef;
            }

            &--red {
                border: 0px;
                background: #d80418;
                color: white;

                &:hover {
                    background: #ad0313 !important;
                }
            }
        }

        &__no-attachments {
            margin-bottom: 34px;
        }

        &__attachments {
            padding-top: 31px;
            border-top: 1px solid #dde0e7;
            margin-top: 26px;
        }

        &__attachments-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 27px;
        }

        &__upload-btn {
            display: flex;
            align-items: center;
            border: 0px;
            padding: 9px 16px;
            background: rgba(220, 228, 238, 0.56);
            border-radius: 4px;
        }

        &__upload-text {
            font-weight: 500;
            font-size: 14px;
            line-height: 132%;
            color: #00082c;
            white-space: nowrap;
            margin-left: 8px;
        }

        &__switch-section {
            display: flex;
            margin-bottom: 10px;
            padding-top: 10px;
        }

        &__tooltip {
            position: relative;
            left: 5px;
            top: -3px;
        }

        &__tip-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 0px;
            background-color: transparent;
            width: 20px;
            height: 20px;
            position: relative;
            cursor: pointer;

            &:hover .hint {
                opacity: 1;
                display: block;
            }
        }
    }

    .file-input {
        display: none;
    }
</style>
